import { fetchGlobalStylesFields, fetchGlobalStylesObject, fetchThemePreset } from 'ContentData/api/GlobalStyles';
import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import { GLOBAL_STYLES_FETCH } from 'ContentData/actions/ActionTypes';
import { mergeDeep } from 'ContentUtils/helpers/ObjectHelpers';
const fetchGlobalStylesAction = createGenericFetchAction(GLOBAL_STYLES_FETCH, async (options = {}, httpClient) => {
  const {
    bufferTheme
  } = options;
  // Fetch fields and the GS object (overrides + activePresetId) in parallel
  const [fields, {
    activePresetId,
    overrides
  }] = await Promise.all([fetchGlobalStylesFields(httpClient), fetchGlobalStylesObject({
    bufferTheme
  }, httpClient)]);

  // If no preset is active, user overrides are the only source of truth
  if (!activePresetId) {
    return {
      fields,
      overrides
    };
  }

  // Fetch the active preset and deep merge its base styles with user overrides
  const presetStyles = await fetchThemePreset(activePresetId, httpClient);
  return {
    fields,
    overrides: mergeDeep(presetStyles, overrides)
  };
});
export const fetchGlobalStyles = (options = {}) => fetchGlobalStylesAction(options);